// Reference Data
import reasons from '../../DropdownReferenceData/reasons.json';
import salutations from '../../DropdownReferenceData/salutations.json';
import times from '../../DropdownReferenceData/times.json';
import transactionValue from '../../DropdownReferenceData/transactionvalue.json';
import poa from '../../DropdownReferenceData/poa.json';
import poi from '../../DropdownReferenceData/poi.json';
import occupations from '../../DropdownReferenceData/occupations.json';
import statesOfUSA from '../../DropdownReferenceData/statesOfUSA.json';
import businessSector from '../../DropdownReferenceData/businessSector.json';
import businessCategory from '../../DropdownReferenceData/businessCategory.json';
import clientTypes from '../../DropdownReferenceData/clientTypes.json';
import portalLanguage from '../../DropdownReferenceData/portalLanguages.json';
import languages from '../../DropdownReferenceData/languages.json';
import industries from '../../DropdownReferenceData/industries.json';
import emailPreferences from '../../DropdownReferenceData/emailPreferences.json';
import employeeStatus from '../../DropdownReferenceData/employeeStatus.json';
import employeeIndustry from '../../DropdownReferenceData/employeeIndustry.json';
// Utils
import GetCountriesData, { GetCountriesDataForDropdown, GetDialingCodeOptions } from '../GetCountriesData';
// Constants
import { DEFAULT_LANGUAGE } from '../Constants/Constants';

const userSelectedLanguage: string = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE;

export const GetDropdownReferenceData = () => ({
  'country': GetCountriesDataForDropdown(),
  'country_excl': GetCountriesDataForDropdown(),
  'currency': { options: [] },
  'dialing': GetDialingCodeOptions('selectList'),
  'reason': reasons[userSelectedLanguage],
  'salutation': salutations[userSelectedLanguage],
  'times': times[userSelectedLanguage],
  'transaction': transactionValue,//Not in Use
  'poa': poa,//Not in Use
  'poi': poi,//Not in Use
  'occupations': occupations[userSelectedLanguage],
  'statesOfUSA': statesOfUSA,
  'businessSector': businessSector[userSelectedLanguage],
  'businessCategory': businessCategory[userSelectedLanguage],
  'clientTypes': clientTypes[userSelectedLanguage],
  'portalLanguage': portalLanguage,
  'employmentStatus': employeeStatus,
  'industryType': employeeIndustry,
  'bankDocumentTypes': employeeIndustry
});

export const GetDropdownReferenceDataForMultiselect = () => ({
  'country': GetCountriesData('setting_multi_select'),
  'dialing': GetDialingCodeOptions('multi_selectList'),
  'language': languages[userSelectedLanguage],
  'industry': industries[userSelectedLanguage],
  'emailPreference': emailPreferences[userSelectedLanguage],
});